import React, { useState } from "react";
import PropTypes from "prop-types";
import pluralize from "pluralize";
import { Box, Flex, Text, Button, Modal } from "samba-ui";
import RegistrationUsersOverview from "./RegistrationUsersOverview";
import InputBox from "./InputBox";

const defaultReason =
  "Your registration request to the Samba TV - Data Analytics was declined. Please reach out to a Samba TV representative if you think this was done in error.";

const DeclineRegistrationModal = ({
  registrations = [],
  isOpen,
  onClose,
  onDeny
}) => {
  const [reason, setReason] = useState(defaultReason);

  const onSubmit = async () => {
    await onDeny(reason);
    onClose();
  };

  const onChange = e => {
    const { value } = e.target;
    setReason(value);
  };

  return (
    <Modal width={592} isOpen={isOpen} onRequestClose={onClose}>
      <Modal.Header borderColor="#d6d6d6 !important">
        <Text>Declining the registration</Text>
      </Modal.Header>
      <Modal.Content>
        {registrations.length && (
          <Box>
            <Box mb={2}>
              <Text fontSize={1} fontWeight={500}>
                {`Denying registrations for the below ${pluralize(
                  "user",
                  registrations.length
                )}`}
              </Text>
            </Box>
            <RegistrationUsersOverview registrations={registrations} />
          </Box>
        )}
        <Box>
          <InputBox
            textarea
            rows={5}
            header="Message in declined email"
            placeholder={defaultReason}
            value={reason}
            onChange={onChange}
          />
        </Box>
      </Modal.Content>
      <Modal.Actions justifyContent="flex-end" borderColor="#d6d6d6 !important">
        <Flex>
          <Box mr={3}>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </Box>
          <Button variant="destructive" onClick={onSubmit} disabled={!reason}>
            Deny
          </Button>
        </Flex>
      </Modal.Actions>
    </Modal>
  );
};

DeclineRegistrationModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onDeny: PropTypes.func,
  registrations: PropTypes.array
};

export default DeclineRegistrationModal;
